const submittedMessageIds = new Set<string>();

export const hasSubmittedFeedback = (messageId: string): boolean => submittedMessageIds.has(messageId);

export const markFeedbackSubmitted = (messageId: string): void => {
  submittedMessageIds.add(messageId);
};

export const clearSubmittedFeedback = (): void => {
  submittedMessageIds.clear();
};
